import React from 'react';
import { Button } from '@fiverr-private/button';
import { Container, Stack } from '@fiverr-private/layout_components';
import { ResponsiveObject } from '@fiverr-private/theme/src/components/Box/types';
import { ButtonSize } from '@fiverr-private/button/dist/esm/src/components/Button/types';
import { AppI18n } from '../../i18n';

interface EditActionsProps {
  onCancel: () => void;
  onEditEnd: () => void;
  isCancelDisabled?: boolean;
  isSaveDisabled?: boolean;
  shouldRemoveSection?: boolean;
  size?: ResponsiveObject<ButtonSize>;
  isCancelVisible?: boolean;
}

export const EditActions = ({
  onCancel,
  onEditEnd,
  isCancelDisabled,
  isSaveDisabled,
  shouldRemoveSection,
  size = 'sm',
  isCancelVisible = true,
}: EditActionsProps) => (
  <Stack alignItems="center" justifyContent="flexEnd">
    {isCancelVisible && (
      <Button disabled={isCancelDisabled} intent="secondary" size={size} variant="ghost" onClick={onCancel}>
        <Container paddingX="3" paddingY="0.5">
          <AppI18n k={shouldRemoveSection ? 'remove' : 'cancel'} />
        </Container>
      </Button>
    )}
    <Button disabled={isSaveDisabled} intent="primary" size={size} variant="outline" onClick={onEditEnd}>
      <Container paddingX="4" paddingY="0.5">
        <AppI18n k="save" />
      </Container>
    </Button>
  </Stack>
);
